import {Attribute} from '../../components/ObjectAttribute';
import {Json} from '../../components/JsonObjectCard';
import searchShipmentsRequest from "./requests/searchShipmentsRequest";
import getShipmentRequest from "./requests/getShipmentRequest";
import packShipmentRequest from "./requests/packShipmentRequest";
import updateShipmentRequest from "./requests/updateShipmentRequest";
import voidShipmentRequest from "./requests/voidShipmentRequest";
import shipShipmentRequest from "./requests/shipShipmentRequest";
import {RequestDefinitionData} from "../../components/RequestDefinition";

const shipmentEndpoints: RequestDefinitionData[] = [
    searchShipmentsRequest,
    getShipmentRequest,
    updateShipmentRequest,
    packShipmentRequest,
    shipShipmentRequest,
    voidShipmentRequest,
];

export const shipmentHeader = {
    title: 'Shipments',
    description: 'This is an object representing a Fishbowl shipment.',
    linkName: 'Shipping',
    link: 'https://help.fishbowlinventory.com/advanced/s/article/Shipping',
    endpoints: shipmentEndpoints,
};

export const jsonObject: Json = {
    title: 'THE SHIPMENT OBJECT',
    json: {
        'id': 15,
        'number': 'S10024-01',
        'order': {
            'id': 21,
            'number': '10024',
            'type': 'SO'
        },
        'carrier': {
            'id': 5,
            'name': 'USPS',
            'service': {
                'id': 16,
                'name': 'Priority Mail'
            }
        },
        'fobPointName': 'Origin',
        'locationGroup': {
            'id': 5,
            'name': 'SLC'
        },
        'lastModified': {
            'dateLastModified': '2026-01-26T03:54:51.001+00:00'
        },
        'shippedBy': 'admin',
        'dateCreated': '2026-01-26T03:54:43.226+00:00',
        'dateShipped': '2026-01-26T03:54:45.115+00:00',
        'note': '',
        'contact': 'Live Big',
        'email': 'brandonbyrge@example.com',
        'phone': '801-932-1101',
        'billOfLading': '00000000000000130',
        'shipToAddress': {
            'name': 'Live Big',
            'street': '789 Byrge Tribute',
            'city': 'LiveBig',
            'state': 'UT',
            'postalCode': '82578',
            'country': 'UNITED STATES'
        },
        'status': 'Shipped',
        'cartons': [
            {
                'id': 15,
                'cartonNumber': 1,
                'trackingNumber': '',
                'freightWeight': '1,1',
                'freightWeightUom': {
                    'id': 3,
                    'name': 'Pound',
                    'abbreviation': 'lbs'
                },
                'freightAmount': '0',
                'sscc': '100000000000000151',
                'dateCreated': '2026-01-26T03:55:50.689+00:00',
                'width': '0',
                'height': '0',
                'length': '0',
                'sizeUom': {
                    'id': 7,
                    'name': 'Inch',
                    'abbreviation': 'in'
                },
                'insuredValue': '0',
                'shipperRelease': false,
                'additionalHandling': false,
                'shipItems': [
                    {
                        'id': 21,
                        'orderItemId': 43,
                        'product': {
                            'id': 37,
                            'name': 'ACB01',
                            'description': 'Accessories - Bike Bell'
                        },
                        'quantity': '1',
                        'uom': {
                            'id': 1,
                            'name': 'Each',
                            'abbreviation': 'ea'
                        },
                        'totalCost': '5.368421053',
                        'tracking': {
                            'trackingItems': [
                                {
                                    'partTracking': {
                                        'id': 2,
                                        'name': 'Lot Number',
                                        'description': ''
                                    },
                                    'value': 'LOT-ABC-2026'
                                },
                                {
                                    'partTracking': {
                                        'id': 1,
                                        'name': 'Serial Number',
                                        'description': ''
                                    },
                                    'serialNumbers': [
                                        {
                                            'numbers': [
                                                {
                                                    'partTracking': {
                                                        'id': 1,
                                                        'name': 'Serial Number',
                                                        'description': ''
                                                    },
                                                    'value': 'SN-12345'
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    },
                    {
                        'id': 22,
                        'orderItemId': 46,
                        'product': {
                            'id': 80,
                            'name': 'B202',
                            'description': 'Premium Brake Cables'
                        },
                        'quantity': '1',
                        'uom': {
                            'id': 1,
                            'name': 'Each',
                            'abbreviation': 'ea'
                        },
                        'totalCost': '9'
                    }
                ]
            }
        ],
        'customFields': [
            {
                'id': 21,
                'name': 'Custom',
                'value': 'Sample text value',
                'type': 'Text'
            }
        ]
    },
};

export const shipmentAttributes: Attribute[] = [
    {
        name: 'id',
        type: 'integer',
        description: 'The shipment\'s unique identification number.'
    },
    {
        name: 'number',
        type: 'string',
        description: 'The shipment number.'
    },
    {
        name: 'order',
        type: 'reference object',
        description: 'The order associated with the shipment.',
        children: [
            {
                name: 'id',
                type: 'integer',
                description: 'The order ID.',
            },
            {
                name: 'number',
                type: 'string',
                description: 'The order number.',
            },
            {
                name: 'type',
                type: 'string',
                description: 'The order type (SO, PO, or TO).',
            },
        ]
    },
    {
        name: 'status',
        type: 'string',
        description: 'The shipment status.'
    },
    {
        name: 'carrier',
        type: 'reference object',
        description: 'The shipping carrier.',
        children: [
            {
                name: 'id',
                type: 'integer',
                description: 'The unique identification number.',
            },
            {
                name: 'name',
                type: 'string',
                description: 'The name of the object.',
            },
            {
                name: 'service',
                type: 'reference object',
                optional: true,
                description: 'The carrier service.',
                children: [
                    {
                        name: 'id',
                        type: 'integer',
                        description: 'The unique identification number.',
                    },
                    {
                        name: 'name',
                        type: 'string',
                        description: 'The name of the object.',
                    },
                ]
            }
        ]
    },
    {
        name: 'fobPointName',
        type: 'string',
        description: 'Indicates when ownership/liability of the shipment transfers.'
    },
    {
        name: 'locationGroup',
        type: 'reference object',
        description: 'The location group the shipment belongs to.',
        children: [
            {
                name: 'id',
                type: 'integer',
                description: 'The unique identification number.',
            },
            {
                name: 'name',
                type: 'string',
                description: 'The name of the object.',
            }
        ]
    },
    {
        name: 'lastModified',
        type: 'object',
        description: 'Timestamp of when the shipment was last modified.',
        children: [
            {
                name: 'dateLastModified',
                type: 'date',
                description: 'The date last modified.',
            }
        ]
    },
    {
        name: 'dateCreated',
        type: 'date',
        description: 'Timestamp of when the shipment was created.',
    },
    {
        name: 'note',
        type: 'string',
        description: 'The shipment\'s note field.',
    },
    {
        name: 'contact',
        type: 'string',
        description: 'The contact name for the shipment.',
    },
    {
        name: 'email',
        type: 'string',
        description: 'The contact email address for the shipment.',
    },
    {
        name: 'phone',
        type: 'string',
        description: 'The contact phone number for the shipment.',
    },
    {
        name: 'billOfLading',
        type: 'string',
        description: 'The bill of lading number.',
    },
    {
        name: 'shipToAddress',
        type: 'object',
        description: 'The shipping address on the shipment.',
        children: [
            {
                name: 'name',
                type: 'string',
                description: 'The name on the address.',
            },
            {
                name: 'street',
                type: 'string',
                description: 'The street line.',
            },
            {
                name: 'city',
                type: 'string',
                description: 'The city.',
            },
            {
                name: 'state',
                type: 'string',
                description: 'The state\'s abbreviation.',
            },
            {
                name: 'postalCode',
                type: 'string',
                description: 'The postal code.',
            },
            {
                name: 'country',
                type: 'string',
                description: 'The country\'s abbreviation.',
            }
        ]
    },
    {
        name: 'shippedBy',
        type: 'string',
        description: 'The username of the user who shipped the shipment.',
    },
    {
        name: 'dateShipped',
        type: 'date',
        description: 'Timestamp of when the shipment was shipped.',
    },
    {
        name: 'cartons',
        type: 'list',
        description: 'A list of cartons/packages in the shipment.',
        children: [
            {
                name: 'id',
                type: 'integer',
                description: 'The unique identifier for the carton.',
            },
            {
                name: 'cartonNumber',
                type: 'integer',
                description: 'The carton number.',
            },
            {
                name: 'trackingNumber',
                type: 'string',
                description: 'The tracking number for the carton.',
            },
            {
                name: 'freightWeight',
                type: 'quantity',
                description: 'The freight weight of the carton.',
            },
            {
                name: 'freightWeightUom',
                type: 'reference object with abbreviation',
                description: 'The unit of measure for the freight weight.',
                children: [
                    {
                        name: 'id',
                        type: 'integer',
                        description: 'The unique identification number.',
                    },
                    {
                        name: 'name',
                        type: 'string',
                        description: 'The name of the unit of measure.',
                    },
                    {
                        name: 'abbreviation',
                        type: 'string',
                        description: 'The abbreviated name.',
                    },
                ]
            },
            {
                name: 'freightAmount',
                type: 'money',
                description: 'The freight amount/cost for the carton.',
            },
            {
                name: 'sscc',
                type: 'string',
                description: 'The Serial Shipping Container Code (SSCC).',
            },
            {
                name: 'dateCreated',
                type: 'date',
                description: 'Timestamp of when the carton was created.',
            },
            {
                name: 'width',
                type: 'quantity',
                description: 'The width of the carton.',
            },
            {
                name: 'height',
                type: 'quantity',
                description: 'The height of the carton.',
            },
            {
                name: 'length',
                type: 'quantity',
                description: 'The length of the carton.',
            },
            {
                name: 'sizeUom',
                type: 'reference object with abbreviation',
                optional: true,
                description: 'The unit of measure for the carton dimensions.',
                children: [
                    {
                        name: 'id',
                        type: 'integer',
                        description: 'The unique identification number.',
                    },
                    {
                        name: 'name',
                        type: 'string',
                        description: 'The name of the unit of measure.',
                    },
                    {
                        name: 'abbreviation',
                        type: 'string',
                        description: 'The abbreviated name.',
                    },
                ]
            },
            {
                name: 'insuredValue',
                type: 'money',
                description: 'The insured value of the carton.',
            },
            {
                name: 'shipperRelease',
                type: 'boolean',
                description: 'Indicates if shipper release is enabled.',
            },
            {
                name: 'additionalHandling',
                type: 'boolean',
                description: 'Indicates if additional handling is required.',
            },
            {
                name: 'shipItems',
                type: 'list',
                description: 'A list of items in the carton.',
                children: [
                    {
                        name: 'id',
                        type: 'integer',
                        description: 'The unique identifier for the ship item.',
                    },
                    {
                        name: 'orderItemId',
                        type: 'integer',
                        description: 'The order item ID (sales order, purchase order, or transfer order item).',
                    },
                    {
                        name: 'product',
                        type: 'reference object',
                        optional: true,
                        description: 'The product (only present when orderType is SO).',
                        children: [
                            {
                                name: 'id',
                                type: 'integer',
                                description: 'The unique identification number.',
                            },
                            {
                                name: 'name',
                                type: 'string',
                                description: 'The product number.',
                            },
                            {
                                name: 'description',
                                type: 'string',
                                description: 'The product description.',
                            },
                        ]
                    },
                    {
                        name: 'part',
                        type: 'reference object',
                        optional: true,
                        description: 'The part (only present when orderType is PO or TO).',
                        children: [
                            {
                                name: 'id',
                                type: 'integer',
                                description: 'The unique identification number.',
                            },
                            {
                                name: 'name',
                                type: 'string',
                                description: 'The part number.',
                            },
                            {
                                name: 'description',
                                type: 'string',
                                description: 'The part description.',
                            },
                        ]
                    },
                    {
                        name: 'tagNumber',
                        type: 'string',
                        description: 'The inventory tag number.',
                    },
                    {
                        name: 'quantity',
                        type: 'quantity',
                        description: 'The quantity shipped.',
                    },
                    {
                        name: 'uom',
                        type: 'reference object with abbreviation',
                        description: 'The unit of measure for the quantity shipped.',
                        children: [
                            {
                                name: 'id',
                                type: 'integer',
                                description: 'The unique identification number.',
                            },
                            {
                                name: 'name',
                                type: 'string',
                                description: 'The name of the unit of measure.',
                            },
                            {
                                name: 'abbreviation',
                                type: 'string',
                                description: 'The abbreviated name.',
                            },
                        ]
                    },
                    {
                        name: 'totalCost',
                        type: 'money',
                        description: 'The total cost of the item.',
                    },
                    {
                        name: 'tracking',
                        type: 'object',
                        optional: true,
                        description: 'Part tracking information associated with the ship item. Only present when the part has tracking enabled and data exists.',
                        children: [
                            {
                                name: 'trackingItems',
                                type: 'list',
                                description: 'List of all tracking items for this ship item.',
                                children: [
                                    {
                                        name: 'partTracking',
                                        type: 'reference object',
                                        description: 'The part tracking field definition.',
                                        children: [
                                            {
                                                name: 'id',
                                                type: 'integer',
                                                description: 'The unique identification number.',
                                            },
                                            {
                                                name: 'name',
                                                type: 'string',
                                                description: 'The name of the tracking field.',
                                            },
                                            {
                                                name: 'description',
                                                type: 'string',
                                                optional: true,
                                                description: 'The description of the tracking field.',
                                            },
                                        ]
                                    },
                                    {
                                        name: 'value',
                                        type: 'string',
                                        optional: true,
                                        description: 'The tracking value for non-serial number tracking types (e.g., Lot Number, Expiration Date). Dates are formatted as yyyy-MM-dd.',
                                    },
                                    {
                                        name: 'serialNumbers',
                                        type: 'list',
                                        optional: true,
                                        description: 'The serial numbers (only present for serial number tracking items).',
                                        children: [
                                            {
                                                name: 'numbers',
                                                type: 'list',
                                                description: 'A list of serial number values.',
                                                children: [
                                                    {
                                                        name: 'partTracking',
                                                        type: 'reference object',
                                                        description: 'The part tracking field definition.',
                                                        children: [
                                                            {
                                                                name: 'id',
                                                                type: 'integer',
                                                                description: 'The unique identification number.',
                                                            },
                                                            {
                                                                name: 'name',
                                                                type: 'string',
                                                                description: 'The name of the tracking field.',
                                                            },
                                                            {
                                                                name: 'description',
                                                                type: 'string',
                                                                optional: true,
                                                                description: 'The description of the tracking field.',
                                                            },
                                                        ]
                                                    },
                                                    {
                                                        name: 'value',
                                                        type: 'string',
                                                        description: 'The serial number value.',
                                                    },
                                                ]
                                            }
                                        ]
                                    },
                                ]
                            }
                        ]
                    },
                ]
            }
        ]
    },
    {
        name: 'customFields',
        type: 'list',
        description: 'A list of custom fields associated with the shipment.',
        children: [
            {
                name: 'id',
                type: 'integer',
                description: 'The custom field\'s unique identifier.',
            },
            {
                name: 'name',
                type: 'string',
                description: 'The name of the custom field.',
            },
            {
                name: 'value',
                type: 'string',
                description: 'The custom field\'s value.'
            },
            {
                name: 'type',
                type: 'string',
                description: 'The category of the custom field\'s value.'
            },
        ]
    },
];
